
(function () {
  'use strict';
  var root = document.getElementById('vukar-hp-kw');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  var factors = { mechanical: 0.7456998715822702, electrical: 0.746, metric: 0.73549875 };
  var input = root.querySelector('#hk-value');
  var basis = root.querySelector('#hk-basis');
  var output = root.querySelector('#hk-output');
  var formula = root.querySelector('#hk-formula');
  var error = root.querySelector('#hk-error');
  var status = root.querySelector('#hk-status');
  var label = root.querySelector('#hk-input-label');
  var mode = 'hp-to-kw';
  var current = null;
  var nf = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 6 });
  function fmt(n) {
    return n !== 0 && (Math.abs(n) < 0.000001 || Math.abs(n) >= 1e12) ? n.toExponential(6) : nf.format(n);
  }
  function update() {
    status.textContent = '';
    label.textContent = mode === 'hp-to-kw' ? 'Power in horsepower (HP)' : 'Power in kilowatts (kW)';
    root.querySelectorAll('[data-hk-mode]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.hkMode === mode));
    });
    root.querySelectorAll('[data-hk-value]').forEach(function (button) {
      button.textContent = button.dataset.hkValue + (mode === 'hp-to-kw' ? ' HP' : ' kW');
    });
    var raw = input.value.trim();
    var n = Number(raw);
    var factor = factors[basis.value];
    var valid = raw !== '' && input.validity.valid && Number.isFinite(n) && n >= 0 && factor > 0;
    if (!valid) {
      current = null;
      output.textContent = '—';
      formula.textContent = '';
      error.textContent = raw === '' && !input.validity.badInput ? 'Enter a power value to convert.' : 'Enter a valid number of zero or more.';
      input.setAttribute('aria-invalid', 'true');
      return;
    }
    var value = mode === 'hp-to-kw' ? n * factor : n / factor;
    if (!Number.isFinite(value)) {
      current = null;
      output.textContent = '—';
      formula.textContent = '';
      error.textContent = 'That number is too large. Try a smaller value.';
      input.setAttribute('aria-invalid', 'true');
      return;
    }
    input.removeAttribute('aria-invalid');
    error.textContent = '';
    var inUnit = mode === 'hp-to-kw' ? 'HP' : 'kW';
    var outUnit = mode === 'hp-to-kw' ? 'kW' : 'HP';
    current = fmt(n) + ' ' + inUnit + ' = ' + fmt(value) + ' ' + outUnit;
    output.textContent = fmt(value) + ' ' + outUnit;
    formula.textContent = fmt(n) + (mode === 'hp-to-kw' ? ' × ' : ' ÷ ') + String(factor) + ' = ' + fmt(value) + ' ' + outUnit;
    root.querySelector('#hk-basis-note').textContent = 'Using ' + basis.options[basis.selectedIndex].text + '. 1 HP = ' + String(factor) + ' kW.';
  }
  input.addEventListener('input', update);
  basis.addEventListener('change', update);
  root.querySelectorAll('[data-hk-mode]').forEach(function (button) {
    button.addEventListener('click', function () { mode = button.dataset.hkMode; update(); });
  });
  root.querySelectorAll('[data-hk-value]').forEach(function (button) {
    button.addEventListener('click', function () { input.value = button.dataset.hkValue; update(); });
  });
  root.querySelector('#hk-reset').addEventListener('click', function () {
    input.value = '1'; basis.value = 'mechanical'; mode = 'hp-to-kw'; update(); input.focus();
  });
  root.querySelector('#hk-copy').addEventListener('click', async function () {
    if (!current) { status.textContent = 'Enter a valid value first.'; return; }
    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(current + ' (' + basis.options[basis.selectedIndex].text + ')');
      status.textContent = 'Result copied.';
    } catch (e) { status.textContent = 'Select the result above to copy it.'; }
  });
  update();
})();
